require('./src/angular-environment');
module.exports = 'environment';